define('GameDayCore/GDModel/ValueObjects/Linescore/LinescorePitcher',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(LinescorePitcher);

	function LinescorePitcher($data) {
		var vo = VO.ensureVO(this, LinescorePitcher),
			data = $data;

		vo.winning_pitcher = data.winning_pitcher || "";
		vo.first_name = data.first_name || "";
		vo.first = data.first || "";
		vo.id = data.id || "";
		vo.last_name = data.last_name || "";
		vo.last = data.last || "";
		vo.name_display_roster = data.name_display_roster || "";
		vo.wins = data.wins || "";
		vo.losses = data.losses || "";
		vo.era = data.era || "";
		vo.saves = data.saves || "";
		vo.s_wins = data.s_wins || "";
		vo.s_losses = data.s_losses || "";
		vo.s_era = data.s_era || "";
	}

	return LinescorePitcher;
});
